import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerPosLoggedInFooterBannerClick as trackLoggedInClick } from "@faire/web-api--source/events/retailerPos/click/loggedInFooterBanner";
import { trackRetailerPosLoggedOutFooterBannerClick as trackLoggedOutClick } from "@faire/web-api--source/events/retailerPos/click/loggedOutFooterBanner";
import { trackRetailerPosLoggedInFooterBannerView as trackLoggedInView } from "@faire/web-api--source/events/retailerPos/view/loggedInFooterBanner";
import { trackRetailerPosLoggedOutFooterBannerView as trackLoggedOutView } from "@faire/web-api--source/events/retailerPos/view/loggedOutFooterBanner";
import { IRetailerLinkCohortEnum } from "@faire/web-api--source/indigofair/retailers/pos/IRetailerLinkCohortEnum";
import posAbout from "@faire/web-api--source/routes/www/point-of-sale/about";
import * as React from "react";
import styled from "styled-components";
export var POSCohortFooterBanner = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var _usePOSSummary = usePOSSummary(), retailerLinkCohort = _usePOSSummary.retailerLinkCohort, posCompanyName = _usePOSSummary.name;
    var bannerInfo = getBannerInfoByCohort(retailerLinkCohort, posCompanyName);
    var actionRef = useDoActionWhenVisible(function() {
        if (isLoggedInRetailer) {
            trackLoggedInView(retailerLinkCohort);
        } else {
            trackLoggedOutView();
        }
    });
    var handleClick = function() {
        if (isLoggedInRetailer) {
            trackLoggedInClick(retailerLinkCohort);
        } else {
            trackLoggedOutClick();
        }
    };
    return bannerInfo ? /*#__PURE__*/ _jsxs(Container, {
        ref: actionRef,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                align: {
                    mobileAndAbove: "left",
                    tabletAndAbove: "right"
                },
                children: bannerInfo.message
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "secondary",
                linkTo: posAbout(),
                onClick: handleClick,
                style: {
                    minWidth: "124px"
                },
                children: bannerInfo.buttonLabel
            })
        ]
    }) : null;
};
var getBannerInfoByCohort = function(retailerLinkCohort, posCompanyName) {
    switch(retailerLinkCohort){
        case IRetailerLinkCohortEnum.RetailerLinkCohort.NEW:
            return {
                message: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "ZIR0wb",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Faire connects seamlessly with your store's POS system"
                        }
                    ]
                }),
                buttonLabel: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "H3/wAp",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Learn more"
                        }
                    ]
                })
            };
        case IRetailerLinkCohortEnum.RetailerLinkCohort.CHURNED:
            return {
                message: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "OJwTG6",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Try our new & improved POS integrations"
                        }
                    ]
                }),
                buttonLabel: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "H3/wAp",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Learn more"
                        }
                    ]
                })
            };
        case IRetailerLinkCohortEnum.RetailerLinkCohort.INACTIVE:
            return {
                message: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "QIeS8M",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Check out our new & improved "
                        },
                        {
                            type: 1,
                            value: "posCompanyName"
                        },
                        {
                            type: 0,
                            value: " integration"
                        }
                    ],
                    values: {
                        posCompanyName: posCompanyName
                    }
                }),
                buttonLabel: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "g7awCh",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "View POS integration"
                        }
                    ]
                })
            };
        default:
            return undefined;
    }
};
var Container = styled(Column).withConfig({
    componentId: "sc-720d2694-0"
})([
    "padding:",
    ";border-top:1px solid ",
    ";",
    "{padding:",
    ";border-top:none;align-items:flex-end;}",
    "{padding:",
    ";max-width:400px;}"
], getSpacing("4x", "3x"), Core.border.muted, responsiveMediaQueries.tabletAndAbove, getSpacing("4x", 96, "8x"), responsiveMediaQueries.desktopAndAbove, getSpacing("3x", 96, "8x", 0));
